import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 고객별 생산 계획 분석(고객>품목별 요청/생산/누적차이 크로스탭) — AnalysisController#getPlanProductionGrid.
// 다른 크로스탭 화면과 같은 { crosstabHeader, chartHeader, data[].pivotData } 형태이되, 그룹 depth가
// 고객/품목 2단이고 measure(요청/생산/누적차이)가 별도 leaf 필드(analysisIndicator)로 내려온다.
const getPlanProductionGrid = (params) => fpApiUtil.postParams(`${ANALYSIS}/plan-production`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 (customerCd, itemCd)로 드릴다운, useGrouping:'true'.
// changes(FilterParameter)는 컬럼 필터 자체가 1차 미이관이라 항상 빈 객체로 보낸다(§A-6e).
const getPlanProductionChart = (params, changes) =>
  fpApiUtil.postFields(`${ANALYSIS}/plan-production`, { params, changes });

const fpProdCustomerService = { getPlanProductionGrid, getPlanProductionChart };
export default fpProdCustomerService;
